import React from 'react';
import { withRouter } from 'react-router-dom'
import "./Profile.css";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";

class RegisterOption extends React.Component {
    constructor(props) {
        super(props);

        this.register = this.register.bind(this)

    }
    register = (event, index) => {
        event.preventDefault();
        if (index === 1)
            this.props.history.push('/register');
        else
            this.props.history.push('/companyregister');

    }
    render() {
        return (
            <div style={{backgroundImage: 'url(assets/media/bg/bg-5.jpg)'}}>
                <Navbar/>
                <div className="row">

                <div className="col-md-4 text-center" style={{ paddingRight: '2.5%', paddingLeft: '2.5%', paddingTop: '3%', paddingBottom: '7.5%' }}>
                        <div className="card" style={{ padding:'10px',backgroundImage: 'url(assets/media/bg/bg-3.jpg)' }}>
                            {/*begin:Aside*/}
                            <div className="">
                                <div className="">
                                    {/*begin:Aside Content*/}
                                    <div className="">
                                        <a href="#">
                                            <img src="http://96.9.130.101:9000/MOSA/assets/media/logos/logo-5.png" alt="" />
                                        </a>
                                        <h4 className="text-muted text-center">Businesses,Institutuions etc can register here. Business users can not only access MOSA facilities but also book venues for events.</h4>
                                        <br />
                                        <button className="btn btn-primary" style={{ borderRadius: '25px', height: '10%' }} onClick={e => this.register(e, 0)}>Corporate Regster</button>
                                    </div>
                                    {/*end:Aside Content*/}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-8 text-center" style={{ paddingRight: '2.5%', paddingLeft: '2.5%', paddingTop: '3%', paddingBottom: '7.5%' }}>
                        <div className="card" style={{padding:'10px', backgroundImage: 'url(assets/media/bg/bg-3.jpg)' }}>
                            {/*begin:Aside*/}
                            <div className="">
                                <div className="">
                                    {/*begin:Aside Content*/}
                                    <div className="">
                                        <a href="#">
                                            <img src="http://96.9.130.101:9000/MOSA/assets/media/logos/logo-5.png" alt="" />
                                        </a>
                                        <h4 className="text-muted text-center">Individuals can register here.Users can get access to MOSA facilities and book for short durations</h4>
                                        <br />
                                        <button className="btn btn-primary" style={{ borderRadius: '25px', height: '10%' }} onClick={e => this.register(e, 1)}>Individial Register</button>
                                    </div>
                                    {/*end:Aside Content*/}
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
                
                
            </div>
        )
    }
}
export default withRouter(RegisterOption);
